module.exports = __webpack_public_path__ + "img/british.7f738495.png";